import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExploreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"explore"}/>
}
